import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: "100%",
    minHeight: "100vh",

    background: "#F4F7FB",

    overflowX: "hidden",
    overflowY: "auto",

    boxSizing: "border-box",

    padding: 16,

    position: "relative",
  },

  fullWidthGrid: {
    width: "100%",
    margin: 0,
  },

  link: {
    textDecoration: "none",
    width: "100%",
    display: "block",
    color: "inherit",
  },

  // ============================================
  // HERO SECTION
  // ============================================

  heroSection: {
    width: "100%",
    maxWidth: "100%",

    // reduced from 250 -> use 220 (within 200-250 range)
    minHeight: 220,

    borderRadius: 24,

    overflow: "hidden",

    position: "relative",

    background: "linear-gradient(135deg,#0B1F3A 0%,#0F4C81 45%,#1976D2 100%)",

    padding: "42px 42px",

    display: "flex",

    alignItems: "center",

    boxSizing: "border-box",

    boxShadow: "0 18px 40px rgba(15,76,129,0.18)",

    marginBottom: 20,

    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "flex-start",
      padding: "32px 24px",
    },

    [theme.breakpoints.down("sm")]: {
      padding: "24px 18px",
      borderRadius: 18,
    },
  },

  heroOverlay: {
    position: "absolute",
    inset: 0,

    opacity: 0.08,

    backgroundImage:
      "linear-gradient(to right, rgba(255,255,255,0.4) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.4) 1px, transparent 1px)",

    backgroundSize: "40px 40px",
  },

  railwayTrack: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    height: 60,
    opacity: 0.12,
    background:
      "repeating-linear-gradient(90deg,#fff 0px,#fff 18px,transparent 18px,transparent 60px)",
  },

  heroLeft: {
    position: "relative",
    zIndex: 2,

    flex: 1,

    minWidth: 0,

    paddingRight: 30,

    [theme.breakpoints.down("md")]: {
      paddingRight: 0,
    },
  },

  heroBadge: {
    display: "inline-flex",

    alignItems: "center",

    gap: 10,

    background: "rgba(255,255,255,0.12)",

    border: "1px solid rgba(255,255,255,0.12)",

    padding: "8px 16px",

    borderRadius: 30,

    color: "#fff",

    fontSize: 12,

    fontWeight: 600,

    letterSpacing: 0.5,

    marginBottom: 18,
  },

  heroTitle: {
    color: "#fff",

    fontWeight: 800,

    fontSize: 42,

    lineHeight: 1.2,

    letterSpacing: -1,

    [theme.breakpoints.down("sm")]: {
      fontSize: 30,
    },
  },

  heroSubtitle: {
    color: "rgba(255,255,255,0.82)",

    marginTop: 18,

    maxWidth: 700,

    fontSize: 15,

    lineHeight: 1.8,
  },

  heroButtons: {
    display: "flex",

    gap: 14,

    flexWrap: "wrap",

    marginTop: 28,
  },

  primaryButton: {
    background: "#fff",

    color: "#0F4C81",

    fontWeight: 700,

    borderRadius: 12,

    padding: "12px 22px",

    textTransform: "none",

    boxShadow: "none",

    "&:hover": {
      background: "#F5F8FC",
      boxShadow: "none",
    },
  },

  secondaryButton: {
    border: "1px solid rgba(255,255,255,0.25)",

    color: "#fff",

    borderRadius: 12,

    padding: "12px 22px",

    textTransform: "none",

    fontWeight: 600,

    "&:hover": {
      background: "rgba(255,255,255,0.08)",
    },
  },

  // ============================================
  // TRAIN VISUAL
  // ============================================

  trainVisual: {
    width: 420,

    maxWidth: "100%",

    position: "relative",

    zIndex: 2,

    flexShrink: 0,

    [theme.breakpoints.down("md")]: {
      width: "100%",
      marginTop: 30,
    },

    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },

  trainBox: {
    position: "relative",

    width: "100%",

    // reduced from 240 -> 180
    height: 180,
  },

  engine: {
    position: "absolute",

    // raised closer to bottom to fit smaller box
    bottom: 20,

    right: 0,

    width: 160,

    // reduced from 90 -> 72
    height: 72,

    background: "#fff",

    borderRadius: "18px 18px 10px 10px",

    boxShadow: "0 12px 28px rgba(0,0,0,0.2)",
  },

  engineFront: {
    position: "absolute",
    right: -28,
    top: 8,
    width: 35,
    height: 57,
    background: "#E3EAF5",
    borderRadius: "0 12px 12px 0",
  },

  wagon: {
    position: "absolute",

    // raised closer to bottom
    bottom: 20,

    width: 110,

    // reduced from 72 -> 60
    height: 60,

    background: "rgba(255,255,255,0.9)",

    borderRadius: 12,
  },

  wagon1: {
    right: 190,
  },

  wagon2: {
    right: 320,
  },

  wheel: {
    position: "absolute",

    // adjust to match new bottom values
    bottom: -8,

    width: 24,

    height: 24,

    background: "#1E293B",

    borderRadius: "50%",
  },

  // ============================================
  // SECTION
  // ============================================

  sectionHeader: {
    display: "flex",

    justifyContent: "space-between",

    alignItems: "center",

    marginBottom: 18,

    marginTop: 6,
  },

  sectionTitle: {
    fontSize: 20,

    fontWeight: 800,

    color: "#102A43",
  },

  sectionSub: {
    color: "#64748B",

    fontSize: 13,
  },

  // ============================================
  // OPERATION CARDS
  // ============================================

  operationCard: {
    width: "100%",

    maxWidth: "100%",

    height: "100%",

    borderRadius: 20,

    padding: 24,

    background: "#fff",

    border: "1px solid #E2E8F0",

    transition: "0.25s",

    display: "flex",

    flexDirection: "column",

    boxSizing: "border-box",

    overflow: "hidden",

    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 16px 34px rgba(15,23,42,0.08)",
    },

    [theme.breakpoints.down("sm")]: {
      padding: 18,
    },
  },

  operationTop: {
    display: "flex",

    alignItems: "center",

    justifyContent: "space-between",

    marginBottom: 18,
  },

  operationIcon: {
    width: 58,

    height: 58,

    borderRadius: 18,

    background: "linear-gradient(135deg,#E3F2FD,#F8FBFF)",

    display: "flex",

    alignItems: "center",

    justifyContent: "center",
  },

  operationTitle: {
    fontSize: 18,

    fontWeight: 700,

    color: "#102A43",

    marginBottom: 8,
  },

  operationDesc: {
    color: "#64748B",

    fontSize: 13,

    lineHeight: 1.7,

    flex: 1,
  },

  operationActions: {
    display: "flex",

    gap: 10,

    marginTop: 22,
  },

  moduleButton: {
    flex: 1,

    borderRadius: 12,

    textTransform: "none",

    fontWeight: 700,

    padding: "10px 14px",

    boxShadow: "none",
  },

  // ============================================
  // QUICK ACTIONS
  // ============================================

  quickSection: {
    marginTop: 30,
    marginBottom: 30,
  },

  quickCard: {
    width: "100%",

    maxWidth: "100%",

    background: "#fff",

    borderRadius: 18,

    padding: 18,

    border: "1px solid #E2E8F0",

    display: "flex",

    alignItems: "center",

    gap: 16,

    cursor: "pointer",

    transition: "0.2s",

    boxSizing: "border-box",

    overflow: "hidden",

    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 10px 26px rgba(15,23,42,0.06)",
    },

    [theme.breakpoints.down("sm")]: {
      padding: 14,
      gap: 12,
    },
  },

  quickIcon: {
    width: 54,

    height: 54,

    borderRadius: 14,

    background: "#EDF5FF",

    display: "flex",

    alignItems: "center",

    justifyContent: "center",

    flexShrink: 0,
  },

  quickTitle: {
    fontWeight: 700,

    color: "#102A43",

    marginBottom: 4,
  },

  quickSub: {
    fontSize: 12,

    color: "#64748B",
  },

  // ============================================
  // OVERVIEW
  // ============================================

  overviewCard: {
    width: "100%",

    maxWidth: "100%",

    background: "#fff",

    borderRadius: 20,

    padding: 24,

    border: "1px solid #E2E8F0",

    height: "100%",

    boxSizing: "border-box",

    overflow: "hidden",

    [theme.breakpoints.down("sm")]: {
      padding: 18,
    },
  },

  overviewTop: {
    display: "flex",

    alignItems: "center",

    gap: 14,

    marginBottom: 18,
  },

  overviewIcon: {
    width: 56,

    height: 56,

    borderRadius: 16,

    background: "#EDF5FF",

    display: "flex",

    alignItems: "center",

    justifyContent: "center",

    flexShrink: 0,
  },

  overviewTitle: {
    fontWeight: 800,

    color: "#102A43",

    fontSize: 18,
  },

  overviewTitle2: {
    fontWeight: 800,

    color: "#102A43",

    fontSize: 15,
  },

  overviewText: {
    color: "#64748B",

    lineHeight: 1.8,

    fontSize: 13,
  },

  // ============================================
  // MENU
  // ============================================

   menuPaper: {
    borderRadius: 14,
    marginTop: 8,
    minWidth: 260,
    maxHeight: 400,
    border: "1px solid #E2E8F0",
    boxShadow: "0 12px 32px rgba(15,23,42,0.12)",

    /* keep scrolling but show a slim rounded scrollbar */
    overflowY: "auto",

    /* Firefox: thin + custom colors (thumb track) */
    scrollbarWidth: "thin",
    scrollbarColor: "rgba(15,23,42,0.24) rgba(226,232,240,0.6)",

    /* WebKit (Chrome, Edge, Safari): track + thumb styling */
    "&::-webkit-scrollbar": {
      width: 8,
    },
    "&::-webkit-scrollbar-track": {
      background: "rgba(226,232,240,0.6)",
      borderRadius: 8,
    },
    "&::-webkit-scrollbar-thumb": {
      background: "rgba(15,23,42,0.24)",
      borderRadius: 8,
      border: "2px solid transparent",
      backgroundClip: "padding-box",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "rgba(15,23,42,0.36)",
    },
  },

  menuItem: {
    padding: "12px 16px",
  },

  // ============================================
  // FOOTER
  // ============================================

  footer: {
    width: "100%",

    maxWidth: "100%",

    marginTop: 34,

    padding: "18px 22px",

    borderRadius: 18,

    background: "#fff",

    border: "1px solid #E2E8F0",

    display: "flex",

    justifyContent: "space-between",

    alignItems: "center",

    flexWrap: "wrap",

    gap: 10,

    boxSizing: "border-box",

    overflow: "hidden",
  },

  footerText: {
    color: "#64748B",

    fontSize: 12,
  },
}));

export default useStyles;
